// extracted by mini-css-extract-plugin
export var container = "_ro-0";
export var dotAnimation = "_ro-2";
export var dotsLoading = "_ro-1";